<template>
  <div class="organizations-wrapper">
    <van-nav-bar
      class="nav"
      fixed
      placeholder
      title="机构列表"
    />
    <div class="wrapper">
      <p class="title">选择一个机构，开始学习</p>
      <basis-list-wrapper
        target-key="organizations"
      >
        <template v-slot:item="{item}">
          <organization-item :key="item.id" :item="item" />
        </template>
      </basis-list-wrapper>
    </div>
  </div>
</template>

<script>
import { BasisListWrapper } from '@/components/basis'
import { OrganizationItem } from '@/components/item'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'Organizations',
  components: { BasisListWrapper, OrganizationItem },
  mixins: [mixinWxShare],
  created () {
    const isDev = process.env.NODE_ENV === 'development'
    if (!isDev) {
      // 生产环境
    }
  }
}
</script>

<style scoped lang="scss">
.organizations-wrapper {
  @include mh-bgc(100vh, #f4f4f4);
  .nav {
    ::v-deep {
      .van-nav-bar__title {
        @include sc($font-size-xlg, $color-text-heavy);
      }
    }
  }
  .wrapper {
    padding: 19px 16px;
    .title {
      @include sc($font-size-xl, $color-text-heavy);
      @include lw(28px, 500);
      text-align: center;
    }
    .basis-list-wrapper {
      padding: 18px 0;
      .organization-item {
        @include bg-image-png('/teacher/list-bg');
        border-radius: 50px 8px 8px 50px;
        background-color: #fff;
        & + .teacher-item, & + .organization-item {
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
